import React, {useState} from 'react';
import { Button, Form, Modal } from "react-bootstrap";

const TicketStatusCreateModal = ({ show, handleClose }) => {
    const [formData, setFormData] = useState({
        name: '',
        color: '#000000',
    });
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };
    return (
        <>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header className="border-0" closeButton>
                    <Modal.Title className="h5">Create Ticket Status</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Name:</Form.Label>
                            <Form.Control type="text" placeholder="Enter name" />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Color:</Form.Label>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <Form.Control type="color" name="color" value={formData.color} onChange={handleChange} style={{ width: '50%', marginRight: 10 }} />
                            </div>
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer className="border-0">
                    <Button variant="primary" onClick={handleClose}>
                        Save
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default TicketStatusCreateModal;